import {cardTitle, tooltip} from "assets/jss/material-dashboard-pro-react.jsx";
import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";

const formacoesStyle = {
  ...customCheckboxRadioSwitch,
  tooltip,
  cardTitle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    "& small": {
      fontSize: "80%",
      fontWeight: "400"
    }
  },
  cardCategory: {
    marginTop: "10px",
    color: "#999999 !important",
    textAlign: "center"
  },
  description: {
    color: "#999999"
  },
  updateProfileButton: {
    float: "right"
  },
  cursosContainer: {
    "&> div > div > h2": {
      padding: "0",
      margin: "0"
    }
  },
  modalCardTitle: {
    fontSize: "23px",
    position: "relative",
    top: "5px",
    left: "10px"
  },
  tableActions: {
    float: "right",
    marginTop: "-50px"
  },
  searchInput: {
    paddingTop: 0,
    marginTop: 0
  },
  addCourseButton: {
    padding: "5px 12px 5px 10px!important",
    marginLeft: "10px!important"
  },
  buttonConfirm: {
    width: "150px"
  },
  ...buttonStyle,
  ...customSelectStyle,
  selectMenu: {
    zIndex: 9000
  },
  datetime: {
    margin: "15px 0"
  },
  novaFormacaoForm: {
    marginTop: "-20px",
    padding: "0 10px"
  },
  editarFormacaoForm: {
    marginTop: "-20px",
    padding: "0 10px"
  },
  addStuffButton: {
    padding: "5px 12px 5px 10px!important",
    marginLeft: "10px!important"
  },
  formacaoButtons: {
    marginTop: 15,
    textAlign: "center",
    "& > *": {
      marginLeft: "5px",
      marginRight: "5px"
    }
  },
  addForm: {
    padding: "0 10px"
  },
  editButton: {
    color: "#f78200",
    "&:hover, &:focus": {
      color: "#ef7c00"
    }
  },
  details: {
    marginTop: -45,
    "& table": {
      width: "100%",
      "& td:first-child": {
        fontWeight: "bold"
      }
    },
    "& .card": {
      margin: "18px -17px",
      width: "auto"
    }
  }
};

export default formacoesStyle;
